import { appInfo } from "./appinfo.js";
export const menuList = [
  {
    title: "Dashboard",
    icon: "ri-dashboard-fill",
    route: "dashboard",
    access: "vi3499999",
  },

  //Analysis
  {
    title: appInfo?.type == "codems" ? "BECE Analysis" : "Science Analysis",
    icon: "ri-file-list-line",
    route: "menu",
    id: "1214-1232-5621-3112",
    access: ["y4861s33", "y10163"],
    children: [
      {
        title: "2026",
        icon: "ri-calendar-2-line",
        access: ["y4861s33", "y10163"],
        subchildren: [
          {
            title: "Students Analysis",
            route: "bece26.studentsanalysis",
            icon: " ri-group-line",
            access: ["y4861s33"],
          },
          {
            title: "Pins Analysis",
            route: "bece26.pinanalysis",
            icon: " ri-group-line",
            access: ["y10163"],
          },
          
        ],
      },
    ],
  },

  //BECE
  {
    title: appInfo?.type == "codems" ? "BECE" : "Science",
    icon: "ri-file-list-line",
    route: "menu",
    id: "1214-1232-5621-3432",
    access: ["y37800", "y31381", "y99931", "y48633", "y961645","y51456", "y37611"],
    children: [
      // 2026
      {
        title: "2026",
        icon: "ri-calendar-2-line",
        access: ["y37800", "y31381", "y99931", "y48633", "y961645", "y51456", "y37611"],
        subchildren: [
          {
            title: "Student(s)",
            route: "bece26.students",
            icon: " ri-group-line",
            access: ["y37800"],
          },
          {
            title: "Add Student",
            route: "create.student.bece26",
            icon: " ri-user-add-line",
            access: ["y31381"],
          },
          {
            title: "New Center",
            route: "bece26.center.create",
            icon: "ri-add-circle-line",
            access: ["y99931"],
          },
          {
            title: "Centers",
            route: "bece26.centers",
            icon: "ri-checkbox-circle-line",
            access: ["y48633"],
          },
          {
            title: "Photo Album",
            route: "bece26.photoAlbums",
            icon: "ri-file-list-line",
            access: ["y51456"],
          },
          {
            title: "Gazettes",
            route: "bece26.gazettes",
            icon: " ri-file-list-line",
            access: ["y44791"],
          },
          {
            title: "Pending Gazette Request(s)",
            route: "bece26.pendinggazettereq",
            icon: " ri-file-list-line",
            access: ["y81365"],
          },
          {
            title: "Uploaded Gazettes",
            route: "bece26.uploadedgazettes",
            icon: " ri-file-list-line",
            access: ["y82953"],
          },
          {
            title: "Upload Gazette",
            route: "bece26.uploadgazette",
            icon: " ri-file-list-line",
            access: ["y57548"],
          },
          {
          
            title: "Pin Purchase",
            route: "bece26.payments",
            icon: "ri-money-dollar-circle-line",
            access: ["y37611"],
          },
          {
            title: "Pin Purchase Transaction(s)",
            route: "bece26.pin.transactions",
            icon: "ri-history-line",
            access: ["y961645"],
          },
          {
            title: "Pin Request(s)",
            route: "bece26.pin.requests.transactions",
            icon: "ri-history-line",
            access: ["y961645"],
          },
        ],
      },
      // 2025
      {
        title: "2025",
        icon: "ri-calendar-2-line",
        access: [
          "y21744",
          "y64254",
          "y41288",
          "y68184",
          "y76563",
          "y51624",
          "y10535",
          "y26917",
          "y12838",
          "y37611",
          "y99931",
          "y92599",
        ],
        subchildren: [
          {
            title: "Student(s)",
            route: "bece25.students",
            icon: " ri-group-line",
            access: ["y21744", "y64254"],
          },
          {
            title: "Add Student",
            route: "create.student.bece25",
            icon: " ri-user-add-line",
            access: ["y26917"],
          },
          {
            title: "Centers",
            route: "25.bece.centers",
            icon: "ri-checkbox-circle-line",
            access: ["y12838"],
          },
           {
            title: "New Center",
            route: "bece25.center.create",
            icon: "ri-add-circle-line",
            access: ["y99931"],
          },
           {
            title: "Photo Album",
            route: "bece25.photoAlbums",
            icon: "ri-file-list-line",
            access: ["y92599"],
          },
          {
            title: "Gazettes",
            route: "bece25.gazettes",
            icon: " ri-file-list-line",
            access: ["y68184"],
          },
          {
            title: "Pending Gazette Request(s)",
            route: "bece25.pendinggazettereq",
            icon: " ri-file-list-line",
            access: ["y76563"],
          },
          {
            title: "Uploaded Gazettes",
            route: "bece25.uploadedgazettes",
            icon: " ri-file-list-line",
            access: ["y10535"],
          },
          {
            title: "Upload Gazette",
            route: "bece25.uploadgazette",
            icon: " ri-file-list-line",
            access: ["y51624"],
          },
          {
            title: "Grade(s)",
            route: "bece25.grades",
            icon: " ri-file-list-line",
            access: ["y41288"],
          },

          {
            title: "Upload Grade(s)",
            route: "bece25.upload.grades",
            icon: " ri-file-list-line",
            access: ["y41288"],
          },

          {
            title: "Export Grade(s)",
            route: "bece25.export.grades",
            icon: " ri-file-list-line",
            access: [],
          },
          {
            title: "Pin Purchase",
            route: "bece26.payments",
            icon: "ri-money-dollar-circle-line",
            access: ["y37611"],
          },
          {
            title: "Pin Request",
            route: "bece25.pin.requests",
            icon: "ri-more-line",
            access: ["y37611"],
          },
          {
            title: "Pin Transaction(s)",
            route: "bece25.transactions",
            icon: "ri-history-line",
            access: ["y37611"],
          },
          {
            title: "Pending Pin Request(s)",
            route: "bece25.pending.pin.requests",
            icon: "ri-history-line",
            access: ["y37611"],
          },
        ],
      },
    ],
  },

  //BAICE
  {
    title: appInfo?.type == "codems" ? "BAICE" : "Tahfeez",
    icon: "ri-file-list-line",
    route: "menu",
    id: "1214-123-5621-131214",
    access: ["y39592", "y68097", "y9616915", "y99931"],
    children: [
      //2026
      {
        title: "2026",
        icon: "ri-user-2-line",
        access: ["y39592", "y68097", "y9616915"],
        subchildren: [
          {
            title: "Student(s)",
            route: "baice26.students",
            icon: " ri-group-line",
            access: ["y39592"],
          },
          {
            title: "Add Student",
            route: "create.student.bece26",
            icon: " ri-user-add-line",
            access: ["nopam"],
          },
          {
            title: "Centers",
            route: "baice26.centers",
            icon: "ri-checkbox-circle-line",
            access: ["y68097"],
          },
           {
            title: "New Center",
            route: "baice26.center.create",
            icon: "ri-add-circle-line",
            access: ["y57052"],
          },
           {
            title: "Photo Album",
            route: "baice26.photoAlbums",
            icon: " ri-file-list-line",
            access: ["y60940"],
          },
         {
            title: "Gazette",
            route: "baice26.gazettes",
            icon: " ri-file-list-line",
            access: ["y68100"],
          },
          {
            title: "Pending Gazette Request(s)",
            route: "baice26.pendinggazettereq",
            icon: " ri-file-list-line",
            access: ["y41541"],
          },
          {
            title: "Uploaded Gazettes",
            route: "baice26.uploadedgazettes",
            icon: " ri-file-list-line",
            access: ["y25104"],
          },
          {
            title: "Upload Gazette",
            route: "baice26.uploadgazette",
            icon: " ri-file-list-line",
            access: ["y88267"],
          },
          {
            title: "Pin Purchase",
            route: "bece26.payments",
            icon: "ri-money-dollar-circle-line",
            access: [""],
          },
          {
            title: "Pin Purchase Transaction(s)",
            route: "baice26.pin.transactions",
            icon: "ri-history-line",
            access: ["y9616915"],
          },
          {
            title: "Pin Request(s)",
            route: "baice26.pin.requests.transactions",
            icon: "ri-history-line",
            access: ["y9616915"],
          },
        ],
      },
      //2025
      {
        title: "2025",
        icon: "ri-user-2-line",
        access: ["y68097", "y30400", "y90694", "y33611", "y86393", "y81789", "y47112", "y99931"],
        subchildren: [
          {
            title: "Student(s)",
            route: "baice25.students",
            icon: "ri-group-line",
            access: ["y30400", "y90694"],
          },
          {
            title: "Create Student",
            route: "baice25.student.create",
            icon: "ri-user-add-line",
            access: ["y90694"],
          },
          {
            title: "Centers",
            route: "baice25.centers",
            icon: "ri-checkbox-circle-line",
            access: ["y47112"],
          },
           {
            title: "New Center",
            route: "baice25.center.create",
            icon: "ri-add-circle-line",
            access: ["nopam"],
          },
          {
            title: "Photo Album",
            route: "baice25.photoAlbums",
            icon: " ri-file-list-line",
            access: ["y33611"],
          },
          {
            title: "Gazettes",
            route: "baice25.gazettes",
            icon: " ri-file-list-line",
            access: ["y86393"],
          },
          {
            title: "Pending Gazette Request(s)",
            route: "baice25.pendinggazettereq",
            icon: " ri-file-list-line",
            access: ["y41541"],
          },
          {
            title: "Uploaded Gazettes",
            route: "baice25.uploadedgazettes",
            icon: " ri-file-list-line",
            access: ["y10535"],
          },
          {
            title: "Upload Gazette",
            route: "baice25.uploadgazette",
            icon: " ri-file-list-line",
            access: ["y51624"],
          },
          {
            title: "Grade(s)",
            route: "baice25.grades",
            icon: " ri-file-list-line",
            access: ["y40142"],
          },
          {
            title: "Upload Grade(s)",
            route: "baice25.upload.grades",
            icon: " ri-file-list-line",
            access: ["y81789"],
          },
          {
            title: "Export Grade(s)",
            route: "baice25.export.grades",
            icon: " ri-file-list-line",
            access: [],
          },
        ],
      },
    ],
  },

  //QE
  {
    title: appInfo?.type == "codems" ? "QE" : "SAISSCE",
    icon: "ri-file-list-line",
    route: "menu",
    id: "XiWqsuh",
    access: ["y45891"],
    children: [
    {
        title: "QE Management 2026",
        icon: "ri-money-dollar-circle-line",
        access: ["y45891"],
        subchildren: [
         {
            title: "Student(s)",
            route: "qe26.students",
            icon: " ri-group-line",
            access: [""],
          },
          {
            title: "New Student",
            route: "create.student.bece26",
            icon: " ri-user-add-line",
            access: [""],
          },
         
        {
            title: "Centers",
            route: "qe26.centers",
            icon: "ri-checkbox-circle-line",
            access: ["y45891"],
          },
           {
            title: "New Center",
            route: "qe26.center.create",
            icon: "ri-add-circle-line",
            access: ["y19106"],
          },
          {
            title: "Pin Purchase",
            route: "qe26.payments",
            icon: "ri-money-dollar-circle-line",
            access: ["y92774"],
          },
          {
            title: "Pin Request",
            route: "qe26.pin.requests",
            icon: "ri-more-line",
            access: ["y92774"],
          },
          {
            title: "Pin Transaction(s)",
            route: "qe26.pin.transactions",
            icon: "ri-history-line",
            access: ["y92774"],
          },
          {
            title: "Pending Pin Request(s)",
            route: "qe26.pin.requests.transactions",
            icon: "ri-history-line",
            access: ["y92774"],
          },
        ],
      },
      // {
      //   title: "2025",
      //   icon: "ri-calendar-2-line",
      //   access: [
      //     "y71515",
      //     "y22763",
      //     "y86265",
      //     "y87242",
      //     "y12856",
      //     "y64839",
      //     "y70647",
      //     "y85310",
      //   ],
      //   subchildren: [
      //     {
      //       title: "Students",
      //       route: "qe25.students",
      //       icon: " ri-group-line",
      //       access: ["y12856"],
      //     },
      //     {
      //       title: "Add Student",
      //       route: "qe25.addstudent",
      //       icon: " ri-group-line",
      //       access: ["y64839"],
      //     },
      //     {
      //       title: "Gazettes",
      //       route: "qe25.gazettes",
      //       icon: " ri-file-list-line",
      //       access: ["y71515"],
      //     },
      //     {
      //       title: "Pending Gazette Request(s)",
      //       route: "qe25.pendinggazettereq",
      //       icon: " ri-file-list-line",
      //       access: ["y22763"],
      //     },
      //     {
      //       title: " Uploaded Gazettes",
      //       route: "qe25.uploadedgazettes",
      //       icon: " ri-file-list-line",
      //       access: ["y87242"],
      //     },
      //     {
      //       title: "Upload Gazette",
      //       route: "qe25.uploadgazette",
      //       icon: " ri-file-list-line",
      //       access: ["y86265"],
      //     },
      //     {
      //       title: "Grade(s)",
      //       route: "qe25.grades",
      //       icon: " ri-file-list-line",
      //       access: ["y70647"],
      //     },

      //     {
      //       title: "Upload Grade(s)",
      //       route: "qe25.upload.grades",
      //       icon: " ri-file-list-line",
      //       access: ["y85310"],
      //     },
      //     {
      //       title: "Export Grade(s)",
      //       route: "qe25.export.grades",
      //       icon: " ri-file-list-line",
      //       access: [],
      //     },
      //   ],
      // },
      

    ],
  },

  //SAIQE
  {
    title: appInfo?.type == "codems" ? "SAIQE" : "SAIQE",
    icon: "ri-file-list-line",
    route: "menu",
    id: "1214-QWQW5621-QWQW5621-QWQSt44",
    access: ["y87412"],
    children: [
      // 2026
      {
        title: "2026",
        icon: "ri-calendar-2-line",
        access: ["y52800", "y49910"],
        subchildren: [
          // {
          //   title: "Student(s)",
          //   route: "saiqe26.students",
          //   icon: "ri-group-line",
          //   access: ["y52800"],
          // },
          // {
          //   title: "New Student",
          //   route: "saiqe26.student.create",
          //   icon: "ri-user-add-line",
          //   access: ["y49910"],
          // },
          {
            title: "Centers",
            route: "saiqe26.centers",
            icon: "ri-checkbox-circle-line",
            access: ["y45891"],
          },
           {
            title: "New Center",
            route: "saiqe26.center.create",
            icon: "ri-add-circle-line",
            access: ["y20941"],
          },
        ],
      },
      // students
      {
        title: "Student Management",
        icon: "ri-user-2-line",
        access: ["y52800", "y49910"],
        subchildren: [
          {
            title: "2025 Student(s)",
            route: "saiqe25.students",
            icon: "ri-group-line",
            access: ["y52800"],
          },
          {
            title: "2025 Create Student",
            route: "saiqe25.student.create",
            icon: "ri-user-add-line",
            access: ["y49910"],
          },
        ],
      },

      // gazette
      {
        title: " Gazette(s)",
        icon: "ri-user-2-line",
        access: ["y15775", "y17350", "y72650", "y70304"],
        subchildren: [
          {
            title: "2025 Gazettes",
            route: "saiqe25.gazettes",
            icon: " ri-file-list-line",
            access: ["y15775"],
          },
          {
            title: "Pending  2025 Gazette Request(s)",
            route: "saiqe25.pendinggazettereq",
            icon: " ri-file-list-line",
            access: ["y72650"],
          },
          {
            title: "2025 Uploaded Gazettes",
            route: "saiqe25.uploadedgazettes",
            icon: " ri-file-list-line",
            access: ["y17350"],
          },
          {
            title: "Upload 2025 Gazette",
            route: "saiqe25.uploadgazette",
            icon: " ri-file-list-line",
            access: ["y70304"],
          },
        ],
      },
      // grades
      {
        title: " Grade(s)",
        icon: "ri-user-2-line",
        access: ["y27461", "y31711"],
        subchildren: [
          {
            title: "Grade(s)",
            route: "saiqe25.grades",
            icon: " ri-file-list-line",
            access: ["y27461"],
          },

          {
            title: "Upload Grade(s)",
            route: "saiqe25.upload.grades",
            icon: " ri-file-list-line",
            access: ["y31711"],
          },
          {
            title: "Export Grade(s)",
            route: "saiqe25.export.grades",
            icon: " ri-file-list-line",
            access: [],
          },
        ],
      },
    ],
  },

  //years
  // {
  //   title: "Years Management",
  //   icon: "ri-calendar-2-fill",
  //   route: "menu",
  //   id: "I32WrBnjpUwekIkul6wU",
  //   access: [],
  //   subchildren: [
  //     {
  //       title: "Years",
  //       route: "years",
  //       icon: "ri-calendar-2-line",
  //       access: [],
  //     },
  //     // {
  //     //   title: "Add Fees",
  //     //   route: "add-fees",
  //     //   icon: "ri-file-add-line",
  //     //   access: [],
  //     // },
  //   ],
  // },

  //LGA EOS
  {
    title: "Manage L.G.A EOS",
    icon: "ri-group-line",
    route: "menu",
    id: "1211-2312-454321",
    access: ["y73397", "y16371"],
    subchildren: [
      {
        title: "L.G.A DOS",
        route: "lgaEos",
        icon: "ri-group-line",
        access: ["y73397"],
      },
      {
        title: "Add L.G.A DOS",
        icon: "ri-user-add-line",
        route: "newLgaEo",
        access: ["y16371"],
      },
    ],
  },

  // School Rep
  {
    title: "School Rep",
    icon: "ri-school-line",
    route: "menu",
    id: "keC8wLtO9B",
    access: ["y56143", "y46010"],
    subchildren: [
      {
        title: "School Rep",
        route: "schoolRep",
        icon: "ri-school-line",
        access: ["y46010"],
      },
      {
        title: "Add School Rep",
        route: "newSchoolRep",
        icon: "ri-add-circle-line",
        access: ["y56143"],
      },
    ],
  },
  //Zonal EOS
  {
    title: "Manage Zonal EOS",
    icon: "ri-team-line",
    route: "menu",
    id: "wertyuioq98zyug345678",
    access: ["y32394", "y41308"],
    subchildren: [
      {
        title: "Zonal EOS",
        route: "list-zonal-eos",
        icon: "ri-group-line",
        access: ["y32394"],
      },
      {
        title: "Add Zonal EOS",
        icon: "ri-user-add-line",
        route: "eos-zonal-new",
        access: ["y41308"],
      },
    ],
  },

  //USERs
  {
    title: "Manage Users",
    icon: "ri-group-line",
    route: "menu",
    id: "5ZD5sR",
    access: ["y38989", "y93621"],
    subchildren: [
      {
        title: "Users",
        route: "users",
        icon: "ri-group-line",
        access: ["y38989"],
      },
      {
        title: "New User",
        icon: "ri-user-add-line",
        route: "newuser",
        access: ["y93621"],
      },
    ],
  },

  //Lgas
  // {
  //   title: "Manage L.G.A",
  //   icon: "ri-file-list-line",
  //   route: "menu",
  //   id: "pMz9u4066fMWiXxjYNHv",
  //   access: ["y82954", "y75060"],
  //   subchildren: [
  //     {
  //       title: "L.G.A(s)",
  //       route: "ListLga",
  //       icon: "ri-file-list-line",
  //       access: ["y82954"],
  //     },
  //     {
  //       title: "New L.G.A",
  //       icon: "ri-add-line",
  //       route: "CreateLga",
  //       access: ["y75060"],
  //     },
  //   ],
  // },

  //States
  // {
  //   title: "Manage State",
  //   icon: "ri-file-list-line",
  //   route: "menu",
  //   id: "pMz9u4066fMWiXxjYNHvIYENT",
  //   access: ["y82954", "y75060"],
  //   subchildren: [
  //     {
  //       title: "State(s)",
  //       route: "ListState",
  //       icon: "ri-file-list-line",
  //       access: ["y82954"],
  //     },
  //     {
  //       title: "New State",
  //       icon: "ri-add-line",
  //       route: "CreateState",
  //       access: ["y75060"],
  //     },
  //   ],
  // },

  //Zones
  // {
  //   title: "Manage Zones",
  //   icon: "ri-file-list-line",
  //   route: "menu",
  //   id: "pMz9u4066fMWiXxjYNHv",
  //   access: ["y82954", "y75060"],
  //   subchildren: [
  //     {
  //       title: "Zones",
  //       route: "zonesList",
  //       icon: "ri-file-list-line",
  //       access: ["y82954"],
  //     },
  //     {
  //       title: "New Zone",
  //       icon: "ri-add-line",
  //       route: "createZone",
  //       access: ["y75060"],
  //     },
  //   ],
  // },

  {
    title: "Settings",
    icon: "ri-settings-2-fill",
    route: "menu",
    id: "vNSzPf2v",
    access: ["y100qw267", "y82954", "y75060"],
    subchildren: [
      {
        title: "App Info",
        route: "appInfo",
        icon: "ri-wallet-line",
        access: ["y100qw267"],
      },
      {
        title: "Roles",
        route: "roles",
        icon: "ri-group-line",
        access: ["y82954"],
      },
      {
        title: "New Role",
        icon: "ri-user-add-line",
        route: "createRole",
        access: ["y75060"],
      },
    ],
  },
];
